import { LIST_DETECTOR_EVENT } from "../actions/types";

const initialState = {
  detectorEvents: [],
};

const detectorEvents = (state = initialState, action) => {
  switch (action.type) {
    case LIST_DETECTOR_EVENT:
      return { ...state, detectorEvents: action.payload };
    default:
      return state;
  }
};

export default detectorEvents;
